import { OnInit, Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormGroup, FormControl, FormGroupDirective, NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Wrapper } from 'src/app/components/wrapper.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { uiActions } from 'src/app/store/ui.era';
import { environment } from '../../../environments/environment';
import { lastValueFrom, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
/**
 * Created by greg on 15/07/2018.
 */

@Component({
    selector: 'register-component',
    template: `
<div class="authenticate">
    <h1>Sign up</h1>
    <div (click)="auth.googleLogin()"  class="google_btn">
        <div class="round_bg"><img src="../../assets/icons/google-icon.svg"/></div>
        Sign up with Google
    </div>
    <div class="divider">or</div>
    <form name="joi-signup-form" id="joi-signup-form" #signupForm="ngForm">
        <fieldset>
            <mat-form-field class="general">
                <input matInput name="firstname" [(ngModel)]="firstname" placeholder="First name" required/>
                <mat-error>First name is required</mat-error>
            </mat-form-field>
            <mat-form-field class="general">
                <input matInput name="lastname" [(ngModel)]="lastname" placeholder="Last name" required/>
                <mat-error>Last name is required</mat-error>
            </mat-form-field>
            <mat-form-field class="general">
                <input matInput type="email" name="email" [(ngModel)]="email" placeholder="Email" required/>
                <mat-error>Please enter a valid email address</mat-error>
            </mat-form-field>
            <mat-form-field class="general">
                <input matInput type="password" id="password" name="password" [(ngModel)]="password" placeholder="Password" minlength="8" required (ngModelChange)="checkPassword()">
                <mat-error *ngIf="signupForm.controls['password']?.errors?.required">A password is required</mat-error>
                <mat-error *ngIf="signupForm.controls['password']?.errors?.minlength">Password with less than 8 characters</mat-error>
            </mat-form-field>
            <mat-form-field class="general">
                <input 
                  matInput type="password" 
                  name="conf_password" 
                  placeholder="Confirm password"
                  [(ngModel)]="conf_password"
                  (ngModelChange)="checkConfirmPassword()"
                  required>
                <mat-error *ngIf="signupForm.controls['conf_password']?.errors?.required">A confirmation password is required</mat-error>
            </mat-form-field>
            <div class="error" *ngIf="confirmError">Confirm password does not match</div>
            <!-- <div class="g-recaptcha" data-sitekey="6Ld7T2QUAAAAACVplwmfUAllyopfIw2czB7aTzY6" data-callback="dataCallback" data-expired-callback="dataExpiredCallback"></div> -->
            <mat-checkbox class="agreeTandC" name="agreeTandC" color="primary" [(ngModel)]="agreeTandC" required>
                <span>I have read and agree with the&nbsp;<a href="https://www.joi.events/eula" target="_blank">End User License Agreement</a></span>
            </mat-checkbox>
            @if(recatchaErrors.length > 0){
                @for(recaptchaError of recatchaErrors; track recaptchaError){
                    <div class="error">There was an error with the reCAPTCHA, please try again.</div>
                }
            }
            <div class="control">
                <button matButton="filled" color="primary" [disabled]="signupForm.invalid || confirmError" (click)="createUser(signupForm)">Sign up</button>
            </div>
        </fieldset>
        <div class="error_message" *ngIf="error_message" [textContent]="error_message"></div>
    </form>

    <!-- <script type="text/javascript">
      var dataCallback = function(response) {
        console.log({response});
      };
    </script> -->
</div>
`,
    styleUrls: [`./login.page.scss`],
    imports: [MatInputModule, CommonModule, MatFormFieldModule, MatButtonModule, MatCheckboxModule, FormsModule, CommonModule, ReactiveFormsModule],
    standalone: true,
    providers: [ReCaptchaV3Service],
})
export class RegisterComponent extends Wrapper<RegisterComponent> implements OnDestroy {

    public error_message = '';
    private register_subscription;
    recatchaErrors: string[] = [];
    firstname;
    lastname;
    email;
    password;
    conf_password;
    agreeTandC = false;
    confirmError = false
    startedConfirmPassword = false
    private recaptchaV3Service = inject(ReCaptchaV3Service);
    private httpClient = inject(HttpClient);

    constructor() {
      super()
      this.subCallback(this.auth.$errors, error => {
        console.log('error ', error)
        this.error_message = error.data['message']
      })
    }

    checkPassword() {
      if (this.startedConfirmPassword) this.checkConfirmPassword()
    }

    checkConfirmPassword() {
      this.startedConfirmPassword = true
      this.confirmError = this.password !== this.conf_password
    }

    checkPasswords(group: UntypedFormGroup) { // here we have the 'passwords' group
        const pass = group.get('password').value;
        const confirmPass = group.get('conf_password').value;
        return pass === confirmPass ? null : { notSame: true }     
      }

    async createUser(form) {
        this.recatchaErrors = [];
        if (form.invalid || this.auth.creating_user) { return; }
        // this.auth.creating_user = true;
        console.log('Creating user: ', this.email);
        const user_obj = {};
        user_obj['email'] = this.email.toLowerCase();
        user_obj['firstName'] = this.firstname;
        user_obj['lastName'] = this.lastname;
        user_obj['displayName'] = this.firstname + ' ' + this.lastname;
        
        this.store.dispatch(uiActions.updateUIItem('takeover_loading','account'))
        const recaptchaScore = await this.checkRecaptcha('createUser');
        console.log('reCAPTCHA score:', recaptchaScore);
        if(!recaptchaScore || recaptchaScore < 0.5){
          console.log('reCAPTCHA score too low:', recaptchaScore);
          this.store.dispatch(uiActions.updateUIItem('takeover_loading',null))  
          this.error_message = 'reCAPTCHA score too low: ' + recaptchaScore;
          return;
        }
        const user = this.auth.createUser(this.email, this.password, user_obj)
    }
    async checkRecaptcha(recaptchaAction:string): Promise<number> {
      //if (environment.useEmulator) return .51; // skip recaptcha check in dev mode
      return new Promise((resolve, reject) => {
        this.recaptchaV3Service.execute(recaptchaAction).subscribe( {next: async(recaptchaToken: string) => {
          console.log('reCAPTCHA token:', recaptchaToken, ' action:', recaptchaAction);
          const url = environment.functionsURL + 'recaptcha/assessment'
          try{
          const recaptchaResponse: number = await lastValueFrom(this.httpClient.post( url, { recaptchaToken, recaptchaAction, recaptchaKey: environment.recaptchaSiteKey }).pipe(take(1))) as number;
          console.log({recaptchaResponse})
          resolve(recaptchaResponse)
          }catch(e){
            this.recatchaErrors.push('Error validating reCAPTCHA, please try again.')
            console.log('error with recaptcha url ', e)
            this.store.dispatch(uiActions.updateUIItem('takeover_loading',null))  
            reject(e)
          }
        }, error: (error) => {
          console.log('Error executing reCAPTCHA: ', error);
          this.recatchaErrors.push('Error executing reCAPTCHA, please try again.')
          this.store.dispatch(uiActions.updateUIItem('takeover_loading',null))  
          //FIXME: handle recaptcha error  
        }});
      })
    }

    dataCallback(response) {
        // console.log('dataCallback', response);
        window.location.href = '/checkRecaptcha?response=' + encodeURIComponent(response);
    }
    dataExpiredCallback() {
        console.log('dataExpiredCallback');
    }

    ngOnDestroy() {
      if (this.register_subscription) this.register_subscription.unsubscribe()
    }
}
